import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import loaderClasses from './Loader.module.scss';

export default function Loader({
  size = 'normal',
  color = 'primary',
  message,
  className,
}) {
  const cs = cx(
    loaderClasses.loader,
    {
      [loaderClasses[`${color}`]]: color !== undefined,
      [loaderClasses[`${size}`]]: size !== undefined,
    },
    className,
  );
  return (
    <>
      <div className={cs} />
      {message && <div className={loaderClasses.message}>{message}</div>}
    </>
  );
}

Loader.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  size: PropTypes.oneOf(['small', 'normal', 'big']),
  color: PropTypes.oneOf(['primary', 'white']),
};
